import { render, staticRenderFns } from "./CustomComfortCredit.vue?vue&type=template&id=495cfb10"
import script from "./CustomComfortCredit.vue?vue&type=script&lang=js"
export * from "./CustomComfortCredit.vue?vue&type=script&lang=js"
import style0 from "./CustomComfortCredit.vue?vue&type=style&index=0&id=495cfb10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports